import * as Yup from 'yup';
import { SarlaftCallInfo } from '../../../../../../shared/types/modules/sarlaft';

export const initialValues: SarlaftCallInfo = {
    callId: '',
    channel: '',
};

export const validationSchema = Yup.object({
    callId: Yup.string()
        .max(
            100,
            'El call ID debe tener 100 caracteres alfanuméricos como máximo'
        )
        .required('El call id es obligatorio'),
    channel: Yup.string().required('El canal es obligatorio'),
});
